import React from 'react'

function ChevronLeftIcon({
   className = "w-6 h-6 fill-white"
}) {
   return (
      <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
         <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
      </svg>
   )
}

export default ChevronLeftIcon